import Collapse from 'bootstrap/js/dist/collapse';

// This function will attempt to close all elements passed in, as if they were Bootstrap collapse elements
// Generally this would be called when they are open and a click is registered elsewhere in the page, matching how dropdowns work
export const closeAllCollapses = (collapses: NodeListOf<HTMLElement>) => {
    for (const collapse of collapses) {
        const collapseItem = new Collapse(collapse, {
            toggle: false,
        });
        collapseItem.hide();
    }
};
